﻿﻿export interface IPairStatusChangeRequest {
    chainId: number;
    clusterNumber: number;
    positionNumber: number;
    pairStatus: number;
    transplantDate: string;
    shippedMethod: number;
    swapType: number;
    transportationCost: number;
    logisticsProvider: number;
}
